{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Chrome-Erweiterung ist nicht installiert.",
      "CTA": "Erweiterung installieren"
    },
    "STATUS": {
      "OFFLINE": "Telefon offline",
      "IN_OTHER_TAB": "Telefon in einem anderen Tab verbunden",
      "CONNECTING": "Verbinden...",
      "DISCONNECTING": "Trennen...",
      "ONLINE": "Telefon online",
      "DIALING": "Wählt",
      "TRANSFERRING": "Weiterleiten...",
      "CONSULTING": "Gespräch mit Kollegen",
      "CALLER_ON_HOLD": "Anrufer wird gehalten",
      "BUSY": "Besetzt",
      "DND": "DND",
      "UNAVAILABLE": "Nicht verfügbar",
      "REJECTED": "Anruf abgelehnt",
      "CALL_FAILED": "Anruf fehlgeschlagen"
    },
    "QUEUES": {
      "MORE": "Weitere Warteschlangen"
    },
    "TABS": {
      "PHONE": "Telefon",
      "SMS": "SMS",
      "HISTORY": "Verlauf"
    },
    "HISTORY": {
      "OPEN": "Öffnen",
      "RECENT": "Kürzlich",
      "MISSED": "Verpasst",
      "LOADING": "Anrufe werden geladen...",
      "EMPTY": "Keine Anrufe",
      "ERROR": "Anrufe konnten nicht geladen werden",
      "CALL": "Zurückrufen",
      "CALL_STATUS": {
        "BUTTON": "Anrufstatus festlegen",
        "TITLE": "Anrufstatus",
        "SEARCH_PLACEHOLDER": "Status suchen...",
        "LOADING": "Status werden geladen...",
        "NO_OPTIONS": "Es wurden keine Anrufstatus konfiguriert",
        "NO_MATCH": "Kein passender Status gefunden",
        "OPTIONS_ERROR": "Status konnten nicht geladen werden",
        "RETRY": "Erneut versuchen",
        "CONFIRM_QUESTION": "„{status}“ festlegen und den Fall schließen?",
        "CONFIRM": "Bestätigen",
        "BACK": "Zurück",
        "CANCEL": "Abbrechen",
        "SAVING": "Speichern...",
        "SAVE_ERROR": "Der Status konnte nicht gespeichert werden",
        "RESOLVE_ERROR": "Status gespeichert, aber der Fall konnte nicht geschlossen werden"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Telefonnummer, z. B. +421903000000",
      "BODY_PLACEHOLDER": "Nachricht schreiben ...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "SMS senden",
      "SENDING": "Wird gesendet ...",
      "SENT": "SMS gesendet",
      "LOADING": "SMS-Posteingänge werden geladen ...",
      "NO_INBOX": "Dieses Konto hat keinen SMS-Posteingang, daher kann keine SMS gesendet werden.",
      "INVALID_NUMBER": "Geben Sie die Nummer im internationalen Format ein, einschließlich des führenden +.",
      "ERROR": "Die SMS konnte nicht gesendet werden. Bitte versuchen Sie es erneut."
    },
    "ACTIONS": {
      "CONNECT": "Verbinden",
      "GO_TO_TAB": "Zu diesem Tab wechseln",
      "DISCONNECT": "Trennen",
      "ANSWER": "Annehmen",
      "HANGUP": "Auflegen",
      "HOLD": "Halten",
      "MUTE": "Mikrofon stummschalten",
      "SILENCE": "Audio stummschalten",
      "TRANSFER": "Weiterleiten",
      "COMPLETE_TRANSFER": "Weiterleitung abschließen",
      "RETURN_TO_CALLER": "Zurück zum Anrufer",
      "CANCEL_TRANSFER": "Weiterleitung abbrechen",
      "DIALPAD": "Wähltastatur anzeigen",
      "OPEN_CONVERSATION": "Unterhaltung öffnen"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Eingehender Anruf",
      "INCOMING_CALL_FROM": "Eingehender Anruf von {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Eingehender Anruf von {number}",
      "ANSWER": "Annehmen",
      "DECLINE": "Ablehnen"
    },
    "TRANSFER": {
      "TITLE": "Anruf weiterleiten",
      "PLACEHOLDER": "Zielnummer für Weiterleitung eingeben...",
      "SEARCH_PLACEHOLDER": "Agenten suchen...",
      "TARGET_PLACEHOLDER": "Ausgewähltes Weiterleitungsziel",
      "CONFIRM": "Weiterleiten",
      "MODE_DIRECT": "Sofort weiterleiten",
      "MODE_CONSULT": "Zuerst Kollegen anrufen",
      "CANCEL": "Abbrechen"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Sind Sie sicher, dass Sie in allen Warteschlangen eine Pause einlegen möchten?",
      "CONFIRM_READY": "Sind Sie sicher, dass Sie in allen Warteschlangen wieder auf Bereit wechseln möchten?",
      "CONFIRM_BREAK_QUEUE": "Möchten Sie sich wirklich von der Warteschlange {queue} abmelden?",
      "CONFIRM_READY_QUEUE": "Möchten Sie sich wirklich bei der Warteschlange {queue} anmelden?",
      "LOGIN_TO_QUEUE": "Anmelden",
      "LOGOUT_FROM_QUEUE": "Abmelden",
      "LOGIN_TO_ALL_QUEUES": "Bei allen Warteschlangen anmelden",
      "LOGOUT_FROM_ALL_QUEUES": "Von allen Warteschlangen abmelden",
      "OPTION_LOGOUT": "Abmelden",
      "OPTION_BREAK": "Pause",
      "OPTION_LUNCH": "Mittagspause",
      "OPTION_AWAY": "Abwesend",
      "OPTION_DO_NOT_DISTURB": "Nicht stören",
      "OPTION_BUSINESS_TRIP": "Geschäftsreise",
      "CONFIRM": "Bestätigen",
      "CANCEL": "Abbrechen"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Keine Verbindung zum Telefonsystem",
      "MESSAGE": "Ihre Internetverbindung scheint nicht zu funktionieren. Bitte überprüfen Sie sie und versuchen Sie es erneut.",
      "CREDENTIALS_TITLE": "Das Telefonsystem hat Ihre Anmeldedaten abgelehnt",
      "CREDENTIALS_MESSAGE": "Das Telefonsystem hat den in Ihrem Profil gespeicherten Benutzernamen oder das Passwort abgelehnt. Überprüfen Sie diese in den Profileinstellungen oder wenden Sie sich an Ihren Administrator.",
      "CONFIGURATION_TITLE": "Telefoneinstellungen sind ungültig",
      "CONFIGURATION_MESSAGE": "Der SIP-Benutzername oder die Serveradresse hat kein gültiges Format, daher kann das Telefon keine Verbindung herstellen. Korrigieren Sie dies in den Profileinstellungen.",
      "NETWORK_SHORT": "Verbindung fehlgeschlagen",
      "CREDENTIALS_SHORT": "Anmeldedaten abgelehnt",
      "CONFIGURATION_SHORT": "Ungültige Telefoneinstellungen",
      "RETRY": "Erneut versuchen",
      "DISMISS": "Abbrechen"
    },
    "CONNECTION_QUALITY": "Verbindungsqualität",
    "CONNECTION_QUALITY_EXCELLENT": "Ausgezeichnet",
    "CONNECTION_QUALITY_GOOD": "Gut",
    "CONNECTION_QUALITY_FAIR": "Mittel",
    "CONNECTION_QUALITY_POOR": "Schlecht",
    "CONNECTION_QUALITY_DISCONNECTED": "Getrennt"
  },
  "DIAL_REDIRECT": {
    "DIALING": "Wähle {number}... Sie können diesen Tab schließen.",
    "NO_NUMBER": "Keine Nummer angegeben. Verwenden Sie ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Telefonnummer eingeben...",
    "ACTIONS": {
      "DIAL": "Nummer wählen",
      "DIAL_FROM": "Nummer wählen, von der angerufen wird"
    },
    "DIAL_FROM": {
      "TITLE": "Von der Nummer eines Posteingangs anrufen"
    },
    "VALIDATION": {
      "REQUIRED": "Telefonnummer ist erforderlich",
      "INVALID_FORMAT": "Ungültiges Telefonnummernformat"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Audioeinstellungen & Test",
    "SELECT_DEVICE": "Gerät auswählen...",
    "SYSTEM_DEFAULT": "Systemstandard",
    "SAVED": "Gespeichert",
    "DISCONNECTED_SUFFIX": "nicht verbunden",
    "DEVICE_DISCONNECTED": "Das ausgewählte Gerät ist nicht verbunden. Anrufe nutzen den Systemstandard, bis es wieder da ist.",
    "MICROPHONE": {
      "TITLE": "Mikrofon",
      "START_TEST": "Mikrofon testen",
      "STOP_TEST": "Test beenden",
      "LEVEL": "Pegel:",
      "VERDICT": {
        "LISTENING": "Sagen Sie etwas ins Mikrofon…",
        "SILENT": "Sie sind nicht zu hören. Prüfen Sie, ob das Mikrofon eingeschaltet und das richtige ausgewählt ist.",
        "LOW": "Sie sind nur leise zu hören. Wählen Sie ein anderes Mikrofon oder passen Sie die Eingangslautstärke in den Systemeinstellungen an.",
        "GOOD": "Guter Klang — Sie sind gut zu hören."
      }
    },
    "SPEAKER": {
      "TITLE": "Lautsprecher",
      "TEST": "Lautsprecher testen",
      "TESTING": "Test läuft...",
      "VOLUME": "Lautstärke:",
      "USING_DEFAULT": "Ausgewählte Ausgabe ist nicht verfügbar — über den Systemstandard wiedergegeben."
    },
    "DONE": "Fertig",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Fehler beim Zugriff auf das Mikrofon. Bitte prüfen Sie die Berechtigungen.",
      "MICROPHONE_PERMISSION_DENIED": "Der Mikrofonzugriff ist blockiert. Erlauben Sie ihn in den Website-Einstellungen Ihres Browsers, um das Telefon zu nutzen.",
      "MICROPHONE_SILENT": "Ihr Mikrofon nimmt keinen Ton auf. Überprüfen Sie Ihre Audioeinstellungen.",
      "EXTENSION_REQUIRED": "Telefon-Erweiterung nicht erkannt. Bitte installieren oder aktivieren Sie sie, um das Mikrofon zu verwenden.",
      "SPEAKER_TEST": "Fehler beim Testen der Lautsprecherausgabe."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "BUSY": "Besetzt"
  },
  "QUEUE_STATUS": {
    "READY": "Bereit",
    "NOT_READY": "Nimmt keine Anrufe an",
    "WRAP_UP": "Nachbearbeitung",
    "BREAK": "Pause",
    "LUNCH": "Mittagspause",
    "AWAY": "Abwesend",
    "DO_NOT_DISTURB": "Nicht stören",
    "BUSINESS_TRIP": "Geschäftsreise",
    "OTHER_CALL": "Anderer Anruf",
    "QUEUE_CALL": "Warteschlangenanruf",
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "NO_ACCESS": "Kein Telefon",
    "PARTIALLY_READY": "Teilweise bereit",
    "MIXED": "Gemischt",
    "CHAT_ONLINE": "Online (Chat)",
    "CHAT_BUSY": "Beschäftigt (Chat)",
    "CHAT_OFFLINE": "Offline (Chat)"
  }
}
